import React, { useEffect, useState } from 'react';
import { FileText, Download, Mail } from 'lucide-react';
import api from '../services/api';
import toast from 'react-hot-toast';

const downloadBlob = async (url, filename) => {
  const res = await api.get(url, { responseType: 'blob' });
  const href = URL.createObjectURL(res.data);
  const a = document.createElement('a');
  a.href = href;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(href);
};

export default function Agreements() {
  const [tenancies, setTenancies] = useState([]);

  useEffect(() => {
    api.get('/tenancies').then(r => setTenancies(r.data.filter(t => t.status === 'ACTIVE'))).catch(console.error);
  }, []);

  const generate = async tenancyId => {
    try {
      const { data } = await api.post(`/agreements/tenancy/${tenancyId}/generate`);
      toast.success('Agreement generated — downloading...');
      await downloadBlob(`/agreements/download/${data.agreement.id}`, `agreement-${tenancyId}.pdf`);
      setTenancies(prev => prev.map(t => t.id === tenancyId ? { ...t, _agreementId: data.agreement.id } : t));
    } catch (err) { toast.error(err.response?.data?.error || 'Error generating agreement'); }
  };

  const download = async agreementId => {
    try {
      await downloadBlob(`/agreements/download/${agreementId}`, `rental-agreement.pdf`);
    } catch (err) { toast.error('Download failed'); }
  };

  const sendEmail = async agreementId => {
    try {
      await api.post(`/agreements/${agreementId}/send-email`);
      toast.success('Email sent to student');
    } catch (err) { toast.error(err.response?.data?.error || 'Error sending email'); }
  };

  return (
    <div>
      <h2 className="text-xl font-bold text-gray-800 mb-6">Rent Agreements</h2>
      <p className="text-sm text-gray-500 mb-4">Generate PDF rental agreements and email them to students.</p>

      <div className="space-y-3">
        {tenancies.map(t => (
          <div key={t.id} className="bg-white rounded-xl p-4 shadow-sm border border-gray-100">
            <div className="flex flex-wrap items-center justify-between gap-3">
              <div>
                <p className="font-semibold text-gray-800">{t.student.firstName} {t.student.lastName}</p>
                <p className="text-xs text-gray-400">{t.student.registrationNo} · Room {t.room.roomNumber} · Rs. {Number(t.monthlyRent).toLocaleString()}/mo</p>
                {t.student.email && <p className="text-xs text-gray-400">{t.student.email}</p>}
              </div>
              <div className="flex gap-2 flex-wrap">
                <button onClick={() => generate(t.id)}
                  className="flex items-center gap-1 text-xs bg-brand-50 text-brand-700 px-3 py-2 rounded-lg hover:bg-brand-100">
                  <FileText size={14} /> Generate PDF
                </button>
                {t._agreementId && (
                  <>
                    <button onClick={() => download(t._agreementId)}
                      className="flex items-center gap-1 text-xs bg-blue-50 text-blue-700 px-3 py-2 rounded-lg hover:bg-blue-100">
                      <Download size={14} /> Download
                    </button>
                    <button onClick={() => sendEmail(t._agreementId)}
                      className="flex items-center gap-1 text-xs bg-green-50 text-green-700 px-3 py-2 rounded-lg hover:bg-green-100">
                      <Mail size={14} /> Email
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>
        ))}
        {tenancies.length === 0 && <div className="text-center text-gray-400 py-16">No active tenancies</div>}
      </div>
    </div>
  );
}
